import CloseContainer from 'components/shared/close-container';
import styles from './deleteAccount.module.scss';

const DeleteAccount = ({ customer, thirdpersonalinfoaccountpage, setToggleDeleteAccount }) => {
  const {
    deleteAccountTitle,
    deleteAccountConfirmMessage,
    confirmDeleteButton,
    cancelDeleteButton,
  } = thirdpersonalinfoaccountpage;

  return (
    <div className={styles.modal}>
      <div className={styles.deleteContainer}>
        <button
          type="button"
          className={styles.closeIconContainer}
          onClick={() => setToggleDeleteAccount(false)}
        >
          <CloseContainer />
        </button>
        <h1 className={styles.title}>{deleteAccountTitle?.text}</h1>
        <p className={styles.confirmMessage}>{deleteAccountConfirmMessage?.text}</p>
        <div className={styles.buttonsContainer}>
          <button
            type="button"
            className={styles.confirmButton}
            onClick={async () => {
              // await deleteAddress(customer.customerAccessToken, address.id);
              // setToggleDeleteAccount(false);
            }}
          >
            {confirmDeleteButton?.text}
          </button>
          <button
            type="button"
            className={styles.cancelButton}
            onClick={() => setToggleDeleteAccount(false)}
          >
            {cancelDeleteButton?.text}
          </button>
        </div>
        {/* {error && <span>{error}</span>} */}
      </div>
    </div>
  );
};

export default DeleteAccount;
